import React, { AnchorHTMLAttributes, FC, MouseEvent, ReactNode } from 'react';
import { callDeepLink } from '@croquiscom/web2app';

import { getAdjustedBrowsingType } from '@common/app-manager';
import { useIsApp } from '@domains/pdp-common';

import { useProductCardContext } from '../../../context/ProductCardContext';
import { DescriptionContainer, ImageContainer, Root } from './Template.styled';

export interface TemplateProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  /**
   * 상품 이미지 컴포넌트
   */
  image?: ReactNode;
  /**
   * 스토어명 컴포넌트
   */
  storeName?: ReactNode;
  /**
   * 상품명 컴포넌트
   */
  productName?: ReactNode;
  /**
   * 상품 할인정보 컴포넌트
   */
  discount?: ReactNode;
  /**
   * 상품 가격 컴포넌트
   */
  price?: ReactNode;
  /**
   * 상품 태그(직진배송, 브랜드 등)  컴포넌트
   */
  tags?: ReactNode;
  /**
   * 리뷰 정보 컴포넌트
   */
  review?: ReactNode;
  /**
   * 리스트 최우측에 표시 할 아이콘(찜 아이콘)
   */
  endIcon?: ReactNode;
}

/**
 * 리스트 형태의 상품 카드 템플릿 컴포넌트
 */
export const Template: FC<React.PropsWithChildren<TemplateProps>> = ({
  image,
  storeName,
  productName,
  discount,
  price,
  tags,
  review,
  endIcon,
  ...rest
}) => {
  const { is_app } = useIsApp();
  const { browsing_type, shop_id, shop_product_no, catalog_product_id } = useProductCardContext();

  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const url = `${window.location.origin}/catalog/products/${catalog_product_id}`;
    if (is_app) {
      return callDeepLink('/product_detail')({
        browsing_type: getAdjustedBrowsingType(browsing_type, url),
        url,
        shop_id,
        shop_product_no,
        catalog_product_id,
      });
    }
    window.location.href = url;
  };

  return (
    <Root {...rest} onClick={onClick}>
      <ImageContainer>{image}</ImageContainer>
      <DescriptionContainer>
        {storeName}
        {productName}
        {discount}
        {price}
        {tags}
        {review}
      </DescriptionContainer>
      {endIcon}
    </Root>
  );
};
